export default __webpack_public_path__ + "static/weather--snow-766d06539649d2fd9dca3c3b2ae6fe34.png";